import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAlertDanger = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 38,
	height: 38,
	viewBox: "0 0 38 38",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			opacity: .3,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M6 19C6 11.8203 11.8203 6 19 6C26.1797 6 32 11.8203 32 19C32 26.1797 26.1797 32 19 32C11.8203 32 6 26.1797 6 19Z",
				stroke: "#D92D20",
				strokeWidth: 2
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			opacity: .1,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M1 19C1 9.05888 9.05888 1 19 1C28.9411 1 37 9.05888 37 19C37 28.9411 28.9411 37 19 37C9.05888 37 1 28.9411 1 19Z",
				stroke: "#D92D20",
				strokeWidth: 2
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_431_4496)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M19.0003 15.667V19.0003M19.0003 22.3337H19.0087M27.3337 19.0003C27.3337 23.6027 23.6027 27.3337 19.0003 27.3337C14.398 27.3337 10.667 23.6027 10.667 19.0003C10.667 14.398 14.398 10.667 19.0003 10.667C23.6027 10.667 27.3337 14.398 27.3337 19.0003Z",
				stroke: "#D92D20",
				strokeWidth: 1.66667,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_431_4496",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 20,
				height: 20,
				fill: "white",
				transform: "translate(9 9)"
			})
		}) })
	]
});
export default SvgAlertDanger;
